export default defineComponent({
  name: 'RenderedSpan',
  props: {
    htmlString: {
      type: String,
      required: true
    }
  }
});